import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Caller } from '../../_models/caller';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';
import { AccessSecurity } from '../../_models/accessSecurity';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss'],
})

export class AuthenticateComponent implements OnInit {

  @ViewChild('pwd', { static: false }) pwd: ElementRef;
  userEmail: string = "";
  userPwd: string = "";
  errorMessage: string = "";
  errorEmail: string = "";
  statusText1: string;
  statusText2: string;
  showPassword: boolean = false;

  apiKeyValue: string;
  providerValue: string;
  redirectUrlValue: string;
  stateValue: string;

  constructor(private alertService: AlertService, public http: HttpClient, private router: Router, public route: ActivatedRoute, public caller: Caller, public user: User, public g: Globals, public accessSec: AccessSecurity) {
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.apiKeyValue = params.apiKey;
        this.providerValue = params.provider;
        this.redirectUrlValue = params.redirectUrl;
        this.stateValue = params.state;
        console.log('Key::' + this.apiKeyValue);
        console.log('providerValue::' + this.providerValue);
        console.log('redirectUrlValue::' + this.redirectUrlValue);
        console.log('stateValue::' + this.stateValue);
      });
    /*     window.onbeforeunload = function () {
          window.history.forward();
        }; */
  }

  validateEmail() {
    this.errorEmail = "";
    if (this.userEmail === 'admin@shift.com') {
      this.showPassword = true;
      setTimeout(() => {
        this.pwd.nativeElement.focus();
      }, 0);
      return;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.userEmail + '&userType=' + 'USER', { headers: header1 })
      .subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.showPassword = false;
          this.errorEmail = "Couldn't find your shift account";
        } else {
          if (data['code'] == 400 && data['message'] == "Email Id Already Exists. ") {
            this.errorEmail = '';
            this.showPassword = true;
            setTimeout(() => {
              this.pwd.nativeElement.focus();
            }, 0);
          } else {
            this.showPassword = false;
            this.errorEmail = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.showPassword = false;
          this.errorEmail = "Please enter valid Email";
        }
      )
  }

  typeEmail() {
    this.statusText1 = "";
    if (this.userEmail === null || this.userEmail === undefined || this.userEmail == '' || this.userEmail === 'undefined') {
      this.errorEmail = '';
      this.statusText1 = ' Please enter Email';
    }
  }

  typePassword() {
    this.statusText2 = "";
    if (this.userPwd == null || this.userPwd === undefined || this.userPwd === '' || this.userPwd === 'undefined') {
      this.statusText2 = 'Please enter Password';
    }
  }

  displayPassword() {
    this.typeEmail();
    if (this.statusText1 !== '') {
      return;
    }
    this.validateEmail();
  }

  submitLogin() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/validateAccountAndApiKey', {
      "provider": this.providerValue,
      "apiKey": this.apiKeyValue,
      "password": this.userPwd,
      "rememberMe": true,
      "username": this.userEmail,
      "redirectUrl": this.redirectUrlValue
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.router.navigate(['/access/authorize']);
          this.g.code = data['encodedKey'];
          localStorage.setItem('jwt', data['idToken']);
          this.g.provider = this.providerValue;
          this.g.redirectUrl = this.redirectUrlValue;
          this.g.state = this.stateValue;
          console.log("provider200::" + this.providerValue);
          console.log("redirectUrl200::" + this.redirectUrlValue);
          console.log("state::200" + this.stateValue);
          /* , { queryParams: { 'code':data['encodedKey']
                            ,'provider':this.providerValue
                            ,'redirectUrl':this.redirectUrlValue
                            ,'state':this.stateValue} }); */
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.g.provider = this.providerValue;
          this.g.redirectUrl = this.redirectUrlValue;
          this.g.state = this.stateValue;
          console.log("providerfail::" + this.providerValue);
          console.log("redirectUrlfail::" + this.redirectUrlValue);
          console.log("state::fail" + this.stateValue);
        });
  }
}
